/* Glimmer — sair da loja sem a tela da Shopify "Are you sure you want to leave Glimmer?".
   A Shopify coloca em todas as páginas um script ("exit interstitial") que, antes de levar o cliente para outro site,
   mostra essa tela em inglês. Ele deixa passar só (1) os sites da lista dela e (2) envio de formulário por POST.
   - glimmerIr(url): vai para o pagamento (InfinitePay) na mesma aba por um formulário POST. A InfinitePay responde
     com um redirecionamento para a própria página de pagamento, então o cliente cai direto no pagamento.
   - Links para fora (WhatsApp, rastreio da transportadora...): abrem numa nova aba direto (o script da Shopify
     não mexe quando outro código já tratou o clique). */
(function () {
  var LIBERADOS = ['shopify.com', 'shop.app', 'facebook.com', 'instagram.com', 'pinterest.com', 'snapchat.com', 'tiktok.com', 'twitter.com', 'vimeo.com', 'x.com', 'youtu.be', 'youtube.com'];
  function liberado(host) {
    if (host === location.hostname) { return true; }
    return LIBERADOS.some(function (h) { return host === h || host.slice(-(h.length + 1)) === '.' + h; });
  }

  window.glimmerIr = function (url) {
    var u;
    try { u = new URL(url, location.href); } catch (e) { location.href = url; return; }
    if (u.origin === location.origin || u.protocol !== 'https:') { location.href = u.href; return; }
    var f = document.createElement('form');
    f.method = 'POST';
    f.action = u.href;
    f.style.display = 'none';
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'origem'; i.value = 'glimmer';
    f.appendChild(i);
    document.body.appendChild(f);
    f.submit();
  };

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download')) { return; }
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (er) { return; }
    if ((u.protocol !== 'https:' && u.protocol !== 'http:') || liberado(u.hostname)) { return; }
    e.preventDefault();
    // Sem "noopener" no window.open (com ele o navegador devolve null mesmo abrindo); corta o vínculo logo depois.
    var w = window.open(u.href, '_blank');
    if (w) { try { w.opener = null; } catch (er) {} }
    if (!w) { if (u.hostname === 'checkout.infinitepay.io') { window.glimmerIr(u.href); } else { location.href = u.href; } }   // nova aba bloqueada: abre na mesma aba
  });
})();

// Carrinho abandonado: o link da mensagem de recuperação (WhatsApp) é /cart?recuperar=<base64 de [[variante, quantidade, 50%?], ...]>.
// Refaz o carrinho com os mesmos produtos e a mesma forma de pagamento e abre o checkout.
(function () {
  var m = location.search.match(/[?&]recuperar=([^&]+)/);
  if (!m) { return; }
  var itens;
  try { itens = JSON.parse(atob(decodeURIComponent(m[1]))); } catch (e) { return; }
  if (!Array.isArray(itens) || !itens.length) { return; }
  var lista = itens.slice(0, 20).map(function (x) {
    return { id: parseInt(x[0], 10), quantity: Math.max(1, parseInt(x[1], 10) || 1), properties: { 'Pagamento': x[2] ? '50% + 50%' : 'Integral' } };
  }).filter(function (x) { return x.id > 0; });
  if (!lista.length) { return; }
  document.documentElement.style.opacity = '0.4';
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lista }) }); })
    .then(function (r) {
      // Algum item esgotado: tenta um por um e segue com o que der.
      if (r.ok) { return; }
      return lista.reduce(function (p, it) {
        return p.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [it] }) }).catch(function () {}); });
      }, Promise.resolve());
    })
    .then(function () { location.replace('/cart?view=checkout'); })
    .catch(function () { location.replace('/cart'); });
})();
